// Shared by the Conversations saved filters and the analytics reports' saved filters — the two
// features present the same save form and the same delete confirmation.

import { ENGLISH_PUNCTUATION_CHAR_CLASS } from "@utils";

export const FILTER_VISIBILITY = {
  PRIVATE: "private",
  SHARED: "shared"
};

export const FILTER_NAME_MAX_LENGTH = 35;

export const FILTER_NAME_ERROR = `Filter name must not exceed ${FILTER_NAME_MAX_LENGTH} characters.`;

// Filter names are English only. Derived from the character set the response validator already
// uses, so a change there reaches filter names too, plus the straight apostrophe and single quotes
// — that validator only allows the curly ’, which no keyboard types, so "Team's view" would be
// rejected. The leading "-" of the shared class must stay first, so the additions go after it.
export const FILTER_NAME_INVALID_CHAR_REGEX = new RegExp(
  `[^a-zA-Z0-9-'‘${ENGLISH_PUNCTUATION_CHAR_CLASS.slice(1)}]`
);

export const FILTER_NAME_LANGUAGE_ERROR = "Filter name must use English characters only.";

export const FILTER_VISIBILITY_LABELS = {
  [FILTER_VISIBILITY.SHARED]: "Everyone",
  [FILTER_VISIBILITY.PRIVATE]: "Only me"
};

export const SHARED_FILTERS_SECTION_LABEL = "Shared filters";
export const MY_FILTERS_SECTION_LABEL = "My filters";

export const DELETE_FILTER_COPY = {
  PRIVATE_BODY: "Deleting this filter will remove it from your list. Are you certain you want to continue?",
  SHARED_BODY: "This is a shared filter. Deleting it will remove it for everyone who uses it.",
  PRIVATE_SUBMIT: "Delete",
  SHARED_SUBMIT: "Delete for everyone"
};

export const SAVE_FILTER_COPY = {
  NAME_LABEL: "Filter name",
  NAME_PLACEHOLDER: "Name",
  VISIBILITY_LABEL: "Visible to",
  CANCEL: "Cancel",
  SAVE: "Save"
};
